import { render, staticRenderFns } from "./DocumentItemCard.vue?vue&type=template&id=1bc26688&scoped=true"
import script from "./DocumentItemCard.vue?vue&type=script&lang=js"
export * from "./DocumentItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc26688",
  null
  
)

export default component.exports